import { Accordion, List } from '@scuf/common';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function InstructionsPage() {
    const [width, setWidth] = useState<number>(0);
    const tam = 845;
    const { t } = useTranslation(['pages', 'home']);

    function handleResize() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        document.title = t('pages:instructions');
        setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    }, []);

    usePreventClickjacking();

    return (
        <div className="container2">
            <div className="contentPageContainer2">
                <div className="container-grande2">
                    <h4>{t('pages:instructions')}</h4>
                    <p>{t('home:instructionsPage.text2')}</p>
                    <Accordion>
                        {/* Limpeza de Cookies e cache do navegador */}
                        <Accordion.Content title={t('home:instructionsPage.tip1')}>
                            <p>{t('home:instructionsPage.tip1Text')}</p>
                            <List bulleted={true}>
                                <List.Content>
                                    {' '}
                                    <a href="https://support.google.com/accounts/answer/32050?hl=pt-BR&co=GENIE.Platform%3DDesktop" target="_blank">
                                        {' '}
                                        Google Chrome
                                    </a>
                                </List.Content>
                                <List.Content>
                                    {' '}
                                    <a href="https://support.microsoft.com/pt-br/microsoft-edge/excluir-cookies-no-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank">
                                        {' '}
                                        Microsoft Edge
                                    </a>
                                </List.Content>
                                <List.Content>
                                    {' '}
                                    <a href="https://support.mozilla.org/pt-BR/kb/limpe-cookies-e-dados-de-sites-no-firefox" target="_blank">
                                        {' '}
                                        Mozilla Firefox
                                    </a>
                                </List.Content>
                            </List>
                        </Accordion.Content>

                        {/* Testar com outros navegadores */}
                        <Accordion.Content title={t('home:instructionsPage.tip2')}>
                            <p>{t('home:instructionsPage.tip2Text')}</p>
                        </Accordion.Content>

                        {/* Acessar com janela anônima */}
                        <Accordion.Content title={t('home:instructionsPage.tip3')}>
                            <p>{t('home:instructionsPage.tip3Text')}</p>
                        </Accordion.Content>

                        {/* Troca de senha */}
                        <Accordion.Content title={t('home:instructionsPage.tip4')}>
                            <p>{t('home:instructionsPage.tip4Text')}</p>
                            <p>{t('home:instructionsPage.tip4Text1')}</p>
                            {width > tam ? <img alt="" src={require('../../assets/password1.png')} /> : <div />}
                            <p>{t('home:instructionsPage.tip4Text2')}</p>
                            {width > tam ? <img alt="" src={require('../../assets/password2.png')} /> : <div />}
                            <p>{t('home:instructionsPage.tip4Text3')}</p>
                            {width > tam ? <img alt="" src={require('../../assets/password3.png')} /> : <div />}
                            <p>{t('home:instructionsPage.tip4Text5')}</p>
                            {width > tam ? <img alt="" src={require('../../assets/password4.png')} /> : <div />}
                            <p>{t('home:instructionsPage.tip4Text6')}</p>
                            {width > tam ? <img alt="" src={require('../../assets/password5.png')} /> : <div />}
                            <p>{t('home:instructionsPage.tip4Text7')}</p>
                            {width > tam ? <img alt="" src={require('../../assets/password6.png')} /> : <div />}
                            <p>{t('home:instructionsPage.tip4Text8')}</p>
                        </Accordion.Content>
                    </Accordion>
                </div>
            </div>
        </div>
    );
}

export default InstructionsPage;
